<template>
  <article class="article-card">
    <div class="article-card__featured-image">
      <!-- Categories -->
      <div v-if="categories && categories.length" class="article-card__category">
        <a :href="`/blog/${categories[0].slug || ''}/`" :aria-label="categories[0].name">
          {{ categories[0].name }}
        </a>
      </div>
      <!-- ./Categories -->

      <!-- Image -->
      <img v-if="thumbnail" :src="thumbnail" :alt="title" loading="lazy" width="100%" height="100%" />
      <!-- ./Image -->
    </div>

    <!-- Title -->
    <a :href="`/blog/${slug}/`" :aria-label="title">
      <h3 :title="title" class="article-card__title" v-html="title" />
    </a>
    <!-- ./Title -->

    <!-- Post Info -->
    <DateAndMinRead :post-date="date" :min-read="minRead" />
    <!-- ./Post Info -->
  </article>
</template>
<script>
import DateAndMinRead from '~/components/blog/DateAndMinRead.vue';

export default {
  name: 'PostCard',
  components: {
    DateAndMinRead,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    slug: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    minRead: {
      type: [String, Number],
      default: null,
    },
    thumbnail: {
      type: String,
      default: null,
    },
    categories: {
      type: Array,
      default: null,
    },
  },
};
</script>
<style lang="scss">
.article-card {
  @apply relative w-full mb-[20px] md:mb-[80px] md:pb-[30px] md:border-b-[1px] border-[#e5e7eb] duration-300;

  &:hover {
    @apply text-orange-500;

    .article-card__featured-image {
      & img {
        @apply scale-110;
      }

      &::after {
        @apply -top-[100%];
      }
    }
  }

  &__category {
    & > a {
      @apply absolute top-0 left-0 rounded-br-[4px] h-[30px] bg-black text-white py-[5px] px-[10px] text-[13px] uppercase z-20 leading-normal;
    }
  }

  &__featured-image {
    @apply relative flex-shrink-0 w-full lg:max-w-[577px] h-[384px] lg:h-[250px] overflow-hidden rounded-[4px] mb-[20px] md:mb-[30px];

    & > img {
      @apply relative duration-500 w-full h-full object-cover;
    }

    &::after {
      content: '';
      @apply absolute inset-0 bg-gray-300 opacity-10 w-full h-full duration-500;
    }
  }

  &__title {
    @apply mb-[12px] md:mb-[20px] leading-normal;

    &::after {
      content: '';
      @apply block absolute z-10 inset-0 pointer-events-auto cursor-pointer w-full h-full;
    }
  }
}
</style>
